<ng-container *inPopulation="[population.Kids]">
  <!--Mobile Nav-->
  <fgb-page-header [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'" [showBanner]="false"></fgb-page-header>
</ng-container>
<ng-container *notInPopulation="[population.Kids]">
  <!--Mobile Nav-->
  <fgb-page-header [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'"></fgb-page-header>
  <!--Sub Nav-->
  <div class="container">
    <fgb-account-nav></fgb-account-nav>
  </div>
</ng-container>
<div class="container" [ngClass]="{ 'kids-activity': isKid }">
  <h5 class="mb-3 transaction-history-heading text-white" [ngClass]="{ 'd-none': isKid }">
    {{ 'transaction.history.title' | translate }}
  </h5>
  <div class="points-history">
    <fgb-transaction-history
      [transactionTypes]="[transactionTypes.loyalty]"
      [accountView]="true"
      [isTransferPage]="false"
    ></fgb-transaction-history>
  </div>
</div>
